<template>
  <div class="page" id="upload">
    <!-- {{progress}} -->
    <div class="upload-form-container">
      <van-form @submit="onSubmit" validate-trigger="onSubmit">
        <div class="courseName">
          {{ courseName }}
        </div>
        <div class="label flex" v-i18n>作品名称</div>
        <van-field
          v-model="form.name"
          name="name"
          :disabled="form.state == 1"
          placeholder="Project Title 作品名称"
          :rules="[{ required: true, message: '请填写作品名称' }]"
        />

        <div class="label flex" v-i18n>添加作品</div>

        <uploader
          @file-added="onFileAdded"
          @file-progress="onFileProgress"
          @file-success="onFileSuccess"
          :options="options"
          class="uploader-example van-uploader"
          refs="uploader"
        >
          <uploader-unsupport></uploader-unsupport>
          <img
            src="@/assets/auditing-bg.png"
            alt=""
            v-if="fileAdded"
            @click="fileAdded = false"
            class="auditing"
          />
          <uploader-drop v-if="!fileAdded">
            <uploader-btn :attrs="attrs">+</uploader-btn>
            <p class="text" v-i18n>选择要上传的文件</p>
          </uploader-drop>
          <uploader-list></uploader-list>
        </uploader>



        <div class="label flex" v-i18n>添加描述</div>
        <van-field
          v-model="form.desc"
          type="textarea"
          autosize
          rows="4"
          name="desc"
          :disabled="form.state == 1"
          placeholder="Dedcrip your project 描述你的作品"
          :rules="[{ required: true, message: '请填写作品描述' }]"
        />
        <div class="btns" v-if="form.state != 1">
          <van-button
            round
            block
            type="info"
            native-type="submit"
            data-state="0"
            @touchstart="onTouch(0)"
            color="linear-gradient(to right, #ffa726, #f5793f, #f25e28)"
            >SAVE 保存</van-button
          >
          <van-button
            round
            block
            type="info"
            native-type="submit"
            data-state="1"
            @touchstart="onTouch(1)"
            color="linear-gradient(to right, #ffa726, #f5793f, #f25e28)"
            >SUBMIT 提交</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import index from "./index.js";
export default { ...index };
</script>

<style lang="scss">
@import "./index.scss";
</style>